angular.module('bmsApp.crm.enquiry').factory('EnquirySvc', function(CRUDSvc, ENQUIRY_API) {

    return {
        index: function(params) {
            return CRUDSvc.get(ENQUIRY_API.INDEX, params);
        },
        create: function(enquiry) {
            return CRUDSvc.post(ENQUIRY_API.CREATE, enquiry);
        },
        read: function(id) {
            return CRUDSvc.get(ENQUIRY_API.READ + id);
        },
        update: function(id, enquiry) {
            return CRUDSvc.post(ENQUIRY_API.UPDATE + id, enquiry);
        },
        convert: function(id, customer) {
            return CRUDSvc.post(ENQUIRY_API.CONVERT + id, customer);
        },
        delete: function(id) {
            return CRUDSvc.get(ENQUIRY_API.DELETE + id);
        },
        options: function(params) {
            return CRUDSvc.get(ENQUIRY_API.OPTIONS, params);
        },
        smConvert: function(params) {
            return CRUDSvc.post(ENQUIRY_API.SM_CONVERT, params);
        },
        gdprCleansing: function(params) {
            return CRUDSvc.post(ENQUIRY_API.GDPR_CLEANSING, params);
        },
        postponeGdprCleansing: function(params) {
            return CRUDSvc.post(ENQUIRY_API.POSTPONE_GDPR_CLEANSING, params);
        },
        geographicalCheck: function(enquiry, license) {
            var customerPost = {
                postcode: enquiry.postcode,
                licenseId: license.id
            };
            return CRUDSvc.get('api/customer/geographic-restriction-check', customerPost);
        },
        licenseReverseLookup: function(params) {
            return CRUDSvc.get('api/customer/postcode-license-reverse-lookup', params);
        },
        export: function(params) {
            var newParams = angular.extend({}, params, {
                'format': 'csv'
            });
            var query = $.param(newParams);
            window.open(ENQUIRY_API.INDEX + '?' + query);
        },
    };

}).constant('ENQUIRY_API', {
    INDEX: 'api/enquiry/index',
    CREATE: 'api/enquiry/create',
    READ: 'api/enquiry/read/',
    UPDATE: 'api/enquiry/update/',
    CONVERT: 'api/enquiry/convert/',
    DELETE: 'api/enquiry/delete/',
    OPTIONS: 'api/enquiry/options',
    SM_CONVERT: 'api/sm/proforma/convert',
    GDPR_CLEANSING: 'api/enquiry/gdpr-cleansing',
    POSTPONE_GDPR_CLEANSING: 'api/enquiry/postpone-gdpr-cleansing',
});